<template>
  <div>
    <v-card class="mx-auto mb-5" outlined>
      <v-card-actions>
        <div class="overline" v-if="entity.id !== undefined">
          ID: {{ entity.id }}
        </div>
        <v-spacer></v-spacer>
        <v-btn text @click="deleteItem" color="primary">Remove</v-btn>
      </v-card-actions>

      <v-list-item>
        <v-list-item-content>
          <v-row>
            <v-col cols="12" md="9">
              <v-select
                label="Entity Type"
                v-model="entity.type_id"
                :items="listEntityTypes"
                :rules="requiredNumberRules"
                item-text="label"
                item-value="id"
                required
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                label="Order"
                v-model="entity.order"
                :rules="requiredNumberRules"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                label="Value"
                v-model="entity.value"
                :rules="requiredRules"
                required
              ></v-textarea>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['entity', 'all', 'index'],
  data() {
    return {
      valid: true,
      requiredRules: [
        (element) => {
          if (element.trim() === '') return 'The field is required';
          return true;
        },
      ],
      requiredNumberRules: [
        (element) => {
          if (element === 0) return 'The field is required';
          return true;
        },
      ],
    };
  },
  created() {
    this.$store.dispatch('law/getEntityTypes', {
      appId: this.$route.params.appId,
    });
  },
  computed: {
    listEntityTypes() {
      return this.$store.state.law.entityTypes;
    },
  },
  methods: {
    deleteItem() {
      this.all.splice(this.index, 1);
    },
  },
};
</script>

<style>
</style>
